// extracted by mini-css-extract-plugin
export default {"checkContainer":"Check_checkContainer__mk4Ky","check":"Check_check__kiIJL","checkText":"Check_checkText__I+CNC"};